import { useSelector } from "react-redux";
import { getConventionsSelector } from "../../../store/conventionsSlice";
import { getFormDifference, isConventionLive } from "../../../utils";
import { getSelfServiceFormSelector } from "../../../store/selfServiceSlice";
import { BRAND } from "../../../utils/constants";
import { getLiveConventionsSelector } from "../../../store/liveConventions";
import { FORM_KEYS } from "../constants";

/**
 * @desc Calculate convention and form difference.
 */
export const useWatchFormAndConvention = () => {
  const conventions = useSelector(getConventionsSelector);
  const liveConventions = useSelector(getLiveConventionsSelector);
  const form = useSelector(getSelfServiceFormSelector);
  const isConventionLiveFunko = isConventionLive(
    BRAND.FUNKO,
    liveConventions
  )(form[FORM_KEYS.CNAME]);
  const isConventionLiveLoungefly = isConventionLive(
    BRAND.LOUNGEFLY,
    liveConventions
  )(form[FORM_KEYS.CNAME]);
  const isConventionLiveMondo = isConventionLive(
    BRAND.MONDO,
    liveConventions
  )(form[FORM_KEYS.CNAME]);

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Calculate form difference.
   */
  const main = () => {
    const difference = getFormDifference({
      conventions,
      form,
    });

    if (form[FORM_KEYS.CNAME]) {
      if (isConventionLiveFunko !== form[FORM_KEYS.IS_PUBLIC_FUNKO]) {
        difference.isLiveFunko = form[FORM_KEYS.IS_PUBLIC_FUNKO];
      }
      if (isConventionLiveLoungefly !== form[FORM_KEYS.IS_PUBLIC_LOUNGEFLY]) {
        difference.isLiveLoungefly = form[FORM_KEYS.IS_PUBLIC_LOUNGEFLY];
      }
      if (isConventionLiveMondo !== form[FORM_KEYS.IS_PUBLIC_MONDO]) {
        difference.isLiveMondo = form[FORM_KEYS.IS_PUBLIC_MONDO];
      }
    }

    return difference;
  };

  // HOOK ---------------------------------------------------------------------

  const difference = main();

  return {
    difference,
    hasDifference: Object.entries(difference).length > 0,
  };
};
